import { handleDramaturgyTypeByFormat } from "../shared/utils/handleDramaturgyTypeByFormat";

export const groupFormatsByDramaturgyType = (formats = []) => {
  return formats.reduce(
    (acc, format) => {
      const group = handleDramaturgyTypeByFormat(format.name);

      if (group) {
        acc[group].push(format.id);
      }

      return acc;
    },
    {
      "Dramaturgia Longa": [],
      "Dramaturgia Curta": [],
    }
  );
};